import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export type ModalImageViewer = {
  url: string;
  title?: string;
}

@Component({
  selector: 'app-modal-image-viewer',
  templateUrl: './modal-image-viewer.component.html',
  styleUrls: ['./modal-image-viewer.component.scss']
})
export class ModalImageViewerComponent implements OnInit {

  @Input() config: ModalImageViewer;
  @Output() close = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

}
